import { floatParser } from "shared/components/forms/BaseInput/parsers";

export const salePriceParser = floatParser({ maxDecimals: 2, max: 99999 });

export const RENT_PMS_SYNCED = `Rent amount is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const RENT_PMS_UNSYNCED = `Rent amount is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;

export const SALE_PRICE_PMS_SYNCED = `Sale price is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const SALE_PRICE_PMS_UNSYNCED = `Sale price is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;
